import { render, staticRenderFns } from "./kargoGorevEkle.vue?vue&type=template&id=2ec1acca"
import script from "./kargoGorevEkle.vue?vue&type=script&lang=js"
export * from "./kargoGorevEkle.vue?vue&type=script&lang=js"
import style0 from "./kargoGorevEkle.vue?vue&type=style&index=0&id=2ec1acca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports